
    import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import { InputValidationRule } from 'vuetify';
    import { ValidationRules } from '@/store/types';
    import { VTextField } from '@/types/Components';

    @Component({
        computed: {
            ...mapState('globals', { globalValidationRules: 'rules' }),
        },
    })
    export default class NumberField extends Vue {
        @Model('change', { type: Number }) public value!: number | null;
        @Prop({ default: () => 6 }) public precision!: number;
        @Prop({ default: () => 2 }) public scale!: number;
        @Prop({ default: () => ',' }) public decimalCharacter!: string;
        @Prop(Boolean) public required!: boolean;

        public $refs!: {
            textField: VTextField;
        };

        public globalValidationRules!: ValidationRules;

        public numberText: string | null = '';

        public mounted(): void {
            this.onChangeValue(this.value);
        }

        public get maxLength(): number {
            return this.precision + (this.scale !== 0 ? 1 : 0) + 1;
        }

        public get attributes(): Record<string, unknown> {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { value, precision, scale, decimalCharacter, required, ...attrs } = this.$attrs;

            return {
                ...attrs,
                rules: this.validationRules,
            };
        }

        public get listeners(): unknown {
            const { change, input } = this.$listeners;

            return {
                ...this.$listeners,
                change: change ? () => (change as (value: number | null) => void)(this.value) : undefined,
                input: input ? () => (input as (value: number | null) => void)(this.value) : undefined,
            };
        }

        public get validationRules(): InputValidationRule[] {
            type NumberFieldAttributes = {
                rules: InputValidationRule[];
            };

            const rules = (this.$attrs as unknown as NumberFieldAttributes).rules ?? [];
            const numericRule = this.globalValidationRules.numeric(this.precision, this.scale);

            return this.required
                ? [this.globalValidationRules.required, numericRule, ...rules]
                : [numericRule, ...rules];
        }

        @Watch('numberText')
        public onChangeNumberText(numberText: string | null): void {
            const converted = parseFloat((numberText ?? '').replace(this.decimalCharacter, '.'));
            this.onChangeValue(isNaN(converted) || !isFinite(converted) ? null : converted);
        }

        @Watch('value')
        public onChangeValue(value: number | null): void {
            this.numberText = value?.toString().replace('.', this.decimalCharacter) ?? null;
            this.$emit('change', value);
        }
    }
